import angular from 'angular';

export default angular.module('shared').constant('alertNotificationConstants', {
    error: 'error',
    info: 'info',
    success: 'success',
    warning: 'warning'
});



// WEBPACK FOOTER //
// ./modules/shared/constants/alertNotification.constant.js